/* eslint-disable max-len */
// Full-colour Atlassian mark: unlike the other glyphs here, it never inherits currentColor —
// the brand mark is always rendered in its own blues, on both light and dark surfaces.
export const AtlassianIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="none">
            <g transform="translate(2.4 2.4) scale(1.8)">
                <g clipPath="url(#clip0_atlassian_icon)">
                    <path fill="#2684FF" d="M7.437 10.28a.556.556 0 0 0-.94.023L.144 22.302a.6.6 0 0 0 .534.87H8.45a.55.55 0 0 0 .5-.312c1.657-3.423.657-8.591-1.513-12.58Z" />
                    <path fill="#0052CC" d="M10.663.5a13.746 13.746 0 0 0-.135 13.671l3.857 7.702a.6.6 0 0 0 .534.328h7.804a.6.6 0 0 0 .534-.868L12.28.501a.87.87 0 0 0-1.617 0Z" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_atlassian_icon">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
